export function action(target, valeur) {

    return [...target.options].some((option, index) => {
        if (option.innerText === valeur) {
            target.selectedIndex = index;
            return true;
        }
    });
}